import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Logout = ({ setIsLoggedIn, setEmail }) => {
  let navigate = useNavigate();

  useEffect(() => {

    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("userData");

    // Navigate back to login
    navigate("/login");
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <h2 className="text-2xl font-bold">Logging out...</h2>
    </div>
  );
};

export default Logout;
